var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"main"},[_c('p',{staticClass:"font-italic pa-5"},[_vm._v("It seems you do not have permissions to any module.")])])])}]

export { render, staticRenderFns }